import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetQuestions, useGetQuestionsList } from "../../hooks/groups/Questions";
import GroupQuestionsListItem from "./GroupQuestionsListItem";
import GroupQuestionsAllList from "./GroupQuestionsAllList";
import GroupQuestionsEditForm from "./GroupQuestionsEditForm";
import LoadingSpinner from "../global/LoadingSpinner";
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

function GroupQuestionsList({ id, index, onSave, list = false }) {
    const { t } = useTranslation();

    // eslint-disable-next-line react-hooks/rules-of-hooks
    let { data, isLoading, isError } = list ? useGetQuestionsList(list) : useGetQuestions(id);
    const [questions, setQuestions] = useState([]);

    const [isNew, setIsNew] = useState(false);
    const [isAvailable, setIsAvailable] = useState(false);

    useEffect(() => {
        if (data) {
            setQuestions(data);
        }
    }, [data]);

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(questions);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setQuestions(items);
        onSave?.({
            type: 'onSave',
            data: items.map(e => e.id),
            index: index,
        });
    };

    const handleAddToModules = (qId) => {
        const updatedData = [...questions.map(e => e.id)];
        if (updatedData.includes(qId)) {
            const idx = updatedData.indexOf(qId);
            updatedData.splice(idx, 1);
        } else {
            updatedData.push(qId);
        }
        onSave?.({
            type: 'onSave',
            data: updatedData,
            index: index,
        });
        setIsAvailable(false);
    };

    if (isError) return 'An error has occurred: ' + isError.message;

    return (
        <>
            <div className="questionsWrap">
                <div className="questionsWrapHeader">
                    <strong className="unbold">{t("admin.group.crit")}</strong>
                </div>
                <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="questions">
                        {(provided) => (
                            <div
                                className="emptyCheck"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {questions.map((question, index) => (
                                    <GroupQuestionsListItem
                                        key={question.id}
                                        index={index}
                                        moduleId={id}
                                        id={question.id}
                                        type={question.answer_type}
                                        text={question.text}
                                        onAddToModule={handleAddToModules}
                                    />
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>

                {isNew && (
                    <GroupQuestionsEditForm
                        id={null}
                        moduleId={id}
                        onNew={handleAddToModules}
                        onClose={() => setIsNew(false)}
                    />
                )}

                {isAvailable && (
                    <>
                        <GroupQuestionsAllList
                            id={id}
                            index="question_ids"
                            moduleId={id}
                            exclude={questions.map(e => e.id)}
                            onAddToModule={handleAddToModules}
                        />
                        <div className="blueBtnWrap blueBtnWrapClose">
                            <button
                                className="btn btn-save btn-close"
                                title="Skrij onemogočene kriterije"
                                onClick={() => setIsAvailable(false)}
                            >
                                {t("admin.common.close")}
                            </button>
                        </div>
                    </>
                )}
            </div>

            <div className="questionsWrap">
                <div className="questionWrap questionWrapNew">
                    <span></span>
                    <p onClick={() => setIsAvailable(true)}>
                        {t("admin.group.aCrit")}
                    </p>
                    <p
                        className="mx-2"
                        onClick={() => {
                            setIsNew(true);
                            setIsAvailable(false);
                        }}
                    >
                        {t("admin.group.anCrit")}
                    </p>
                </div>
            </div>
        </>
    );
}

export default GroupQuestionsList;
